import React from 'react'

import { RecipeTagLabels, type RecipeTagLabel } from '@library/menu-page'
import { Recipe } from '@library/menu-service'

export type StackedRecipeLabelsProps = {
  isOutOfStock: boolean
  recipe: Recipe
  reserveCtaSpace?: boolean
}

const getRecipeGeneralTag = (
  tag: NonNullable<Recipe['merchandisingTags']['availability']>,
): RecipeTagLabel => ({
  type: 'generic',
  text: tag.name,
  backgroundColor: { light: tag.backgroundColor.light },
  color: { light: tag.color.light },
})

const getStackedRecipeLabels = (recipe: Recipe): RecipeTagLabel[] => {
  const { invalidPreference } = recipe

  if (invalidPreference) {
    return [{ type: 'invalidPreference', text: invalidPreference }]
  }

  const tags: RecipeTagLabel[] = []
  const recipeTag = recipe.merchandisingTags.availability
  const brandTag = recipe.merchandisingTags.tagline

  if (recipeTag) {
    tags.push(getRecipeGeneralTag(recipeTag))
  }

  if (brandTag) {
    tags.push(getRecipeGeneralTag(brandTag))
  }

  return tags
}

export const StackedRecipeLabels = ({
  isOutOfStock,
  recipe,
  reserveCtaSpace = false,
}: StackedRecipeLabelsProps) => (
  <RecipeTagLabels
    tags={getStackedRecipeLabels(recipe)}
    isOutOfStock={isOutOfStock}
    reserveEndSpace={reserveCtaSpace}
    stacked
    dataTestId="recipe-tile-general-labels"
    style={{ left: 0 }}
  />
)
